export function validateRequired(
	required: boolean | undefined,
	message: string,
) {
	return {
		required: {
			value: !!required,
			message,
		},
	};
}
